import CreatableSelect from 'react-select/creatable';
import { FaTrash } from 'react-icons/fa6';
import styled from 'styled-components';

const StyledOption = styled.div`
  padding: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  span,
  svg {
    cursor: pointer;
  }

  &:hover {
    color: #fcb12e;
  }
`;

const defaultSelectStyles = {
  control: (styles) => ({ ...styles, backgroundColor: 'white' }),
  option: (styles, { isDisabled, isSelected }) => ({
    ...styles,
    backgroundColor: '#fff',
    color: isDisabled ? '#ccc' : isSelected ? '#fcb12e' : '#4D5C6D',
    ':hover': {
      color: '#fcb12e',
      cursor: 'pointer',
    },
    ':focus': {
      color: '#fcb12e',
      cursor: 'pointer',
    },
    ':active': {
      color: '#fcb12e',
      cursor: 'pointer',
    },
  }),
  multiValue: (styles) => ({
    ...styles,
    backgroundColor: 'rgb(158, 13, 61)',
    color: '#fff',
    fontWeight: 700,
  }),
  multiValueLabel: (styles, { data }) => ({
    ...styles,
    color: data.color,
  }),
  multiValueRemove: (styles, { data }) => ({
    ...styles,
    color: data.color,
  }),
};

export const CreatableTechToolsSelect = ({
  isMulti = true,
  isLoading,
  value,
  options,
  styles,
  placeholder,
  noOptionsMessage,
  formatCreateLabel,
  onChange,
  onCreateOption,
  getUserId,
  onDeleteOption,
  showCreateHandling = false,
  onCreateLabelClick,
  removeZindexStyle = true,
  isClearable = true,
}) => {
  const mergedStyles = {
    ...styles,
    ...{
      menuPortal: base => (removeZindexStyle ? { ...base, zIndex: 1056 } : { ...base })
    }
  } || defaultSelectStyles;

  return (
    <CreatableSelect
      isMulti={isMulti}
      isClearable={isClearable}
      placeholder={placeholder}
      value={value}
      options={options}
      styles={mergedStyles}
      isLoading={isLoading}
      onChange={onChange}
      onCreateOption={onCreateOption}
      noOptionsMessage={noOptionsMessage}
      formatCreateLabel={formatCreateLabel}
      menuPortalTarget={document.body}
      menuPosition="fixed"
      components={{
        Option: (props) => {
          const userId = getUserId?.();
          const opt = props.options.find((option) => option.value === props.value);

          const handleClick = (e) => {
            e.stopPropagation();

            // For the creatable "Create ..." option, delegate the click
            // back to react-select's built-in handler so that it triggers
            // onCreateOption on click (same behavior as pressing Enter).
            if (props.data?.__isNew__) {
              if (props.innerProps && props.innerProps.onClick) {
                props.innerProps.onClick(e);
              }
              return;
            }

            if (showCreateHandling && props.label.includes('Create ')) {
              const content = props.label
                .replace('Create "', '')
                .replace('"', '');

              onCreateLabelClick?.(content, props);
              return;
            }

            props.selectOption({
              label: props.label,
              value: props.value,
            });
          };

          const handleDelete = async (e) => {
            e.stopPropagation();
            if (!opt || !onDeleteOption) return;
            await onDeleteOption(opt);
          };

          return (
            <StyledOption {...props}>
              <span onClick={handleClick}>{props.label}</span>
              {opt?.userId && opt.userId === userId && (
                <FaTrash onClick={handleDelete} style={{ cursor: 'pointer' }} />
              )}
            </StyledOption>
          );
        },
      }}
    />
  );
};

